// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","logo":"Footer_logo__w79hm","bottom":"Footer_bottom__J7kjW","line":"Footer_line__jfISu"};